import { render } from "./HeaderList.vue?vue&type=template&id=15f5bc6c&lang=pug"
import script from "./HeaderList.vue?vue&type=script&lang=js"
export * from "./HeaderList.vue?vue&type=script&lang=js"

import "./HeaderList.vue?vue&type=style&index=0&id=15f5bc6c&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__